import { render, staticRenderFns } from "./ViewCombo.vue?vue&type=template&id=11959ba7&scoped=true&"
import script from "./ViewCombo.vue?vue&type=script&lang=js&"
export * from "./ViewCombo.vue?vue&type=script&lang=js&"
import style0 from "./ViewCombo.vue?vue&type=style&index=0&id=11959ba7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11959ba7",
  null
  
)

export default component.exports